import { casaBool, casaID, casaIgual, casaTexto } from "@/lib/filtros/texto";
import type { Punto } from "@/lib/puntos";

/** CLAVES_PUNTOS son los parámetros que admite el listado de puntos de aislamiento (#247). */
export const CLAVES_PUNTOS = ["fuente", "equipo", "estado", "activo", "q"] as const;

/** FiltrosPuntos es el objeto de filtros del listado de puntos tal como viaja en la URL. */
export type FiltrosPuntos = Partial<Record<(typeof CLAVES_PUNTOS)[number], string>>;

/**
 * filtrarPuntos aplica los filtros en el navegador (modo sin red, D2). Debe dar el MISMO
 * resultado que el SQL del servidor: ver la tabla de casos compartida en
 * backend/internal/factory/filtros_integration_test.go (TestFiltrosPuntosHTTP).
 */
export function filtrarPuntos(filas: Punto[], filtros: FiltrosPuntos): Punto[] {
  return filas.filter(
    (p) =>
      casaID(filtros.fuente, p.id_fuente) &&
      casaID(filtros.equipo, p.id_equipo) &&
      casaBool(filtros.activo, p.activo) &&
      // El estado publicado del punto es la traducción de su booleano derivado (#243).
      casaIgual(filtros.estado, p.bloqueado ? "BLOQUEADO" : "DESBLOQUEADO") &&
      // `q` alcanza también la relación ACTIVA que la propia fila publica (#289): los
      // códigos de los candados que cubren el punto ahora. Es el mismo dato que pinta la
      // columna «Candados» (#248), así que la función pura no necesita pedir nada más; y
      // como un bloqueo retirado no llega en `candados`, la ausencia sale sola.
      casaTexto(filtros.q, p.nombre, p.descripcion, ...p.candados.map((c) => c.codigo_candado)),
  );
}
